import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/input/nameWithCount/styles.scss';export default {
  "name": "_name_3vhon_1",
  "nameWithCount": "_nameWithCount_3vhon_8",
  "count": "_count_3vhon_19"
};